var exports = {
  "m": "ReviewThreadContainer__SkWCuG",
};

module.exports = exports;
